import React from 'react';
import { useSelector } from 'react-redux';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

import { selectSiteUrl } from 'core/selectors/app';
import { selectUserIsIdentified } from 'core/selectors/user';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';

import './ButtonSection.scss';

function ButtonSection() {
  const { customLoginLink = '' } = window;
  const siteUrl = useSelector(selectSiteUrl);
  const userIsIdentified = useSelector(selectUserIsIdentified);
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const logedOutCTAText = isMobileMQ ? 'Sign in and shop' : 'Claim your bonus today';
  const logedInCTAText = 'Start shopping';

  return (
    <div className="mn_buttonWrap">
      {userIsIdentified
        ? (
          <a href={siteUrl} className={`mn_button ${isMobileMQ ? '' : 'mn_secondaryButton'}`}>
            {logedInCTAText}
          </a>
        ) : (
          <a href={customLoginLink} className={`mn_button ${isMobileMQ ? '' : 'mn_secondaryButton'}`}>
            {logedOutCTAText}
          </a>
        )
      }
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><ButtonSection {...props} /></ComponentErrorBoundary>;
